import PricingIntegrationInput from '@app/model/pricing-automation/input/PricingIntegrationInput';
import Utilities from '@util/Utilities';
import { PriceRecommendationState } from '@app/model/market_state/PriceRecommendationState';

export const createPricingIntegrationDefaultValues = (
	statDate: string,
	recommendations: PriceRecommendationState[],
): PricingIntegrationInput => ({
	statDate: statDate,
	rates: recommendations.map((recommendation) => {
		const rooms = recommendation.minimumBasePriceRoomStates;

		return {
			architectureId: recommendation.architectureId,
			recommendationId: recommendation.id,
			roomPrices: rooms.map(room => {
				const submittedPrice = Utilities.roundDouble(recommendation.isValid ? room.finalPrice : room.basePrice, 0);
				return {
					roomId: room.roomId,
					currentPrice: room.basePrice,
					submittedPrice: submittedPrice,
					isAnchor: room.isAnchor,
				};
			}),
		};
	}),
});
